import { createStore } from "zustand/vanilla";
import { useStore } from "zustand";
import type { AppRuntime } from "../../runtime/contracts";
import { useAppRuntime } from "../../providers/AppRuntimeProvider";

export interface SettingsStoreState {
  selectedCategoryId: string | undefined;
  searchQuery: string;
  actions: {
    setSelectedCategoryId: (id: string | undefined) => void;
    setSearchQuery: (query: string) => void;
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function createSettingsStore(_runtime: AppRuntime) {
  return createStore<SettingsStoreState>((set) => ({
    selectedCategoryId: "accounts",
    searchQuery: "",
    actions: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      setSelectedCategoryId: (id) => { set({ selectedCategoryId: id }); },
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      setSearchQuery: (query) => { set({ searchQuery: query }); },
    },
  }));
}

export type SettingsStore = ReturnType<typeof createSettingsStore>;
export function useSettingsStore(): SettingsStoreState;
export function useSettingsStore<T>(selector: (state: SettingsStoreState) => T): T;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function useSettingsStore<T>(selector?: (state: SettingsStoreState) => T) {
  const runtime = useAppRuntime();
  const store = runtime.stores.get<SettingsStore>("settings");
  if (!store) throw new Error("Settings store not initialized");
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  return useStore(store, selector ?? ((s) => s as unknown as T));
}
